import generateUniqueId from '../utils/generateUniqueId';
import { resolveAnimation } from '../utils/resolveAnimation';
var Store = /** @class */ (function () {
    function Store() {
        this.instances = [];
        this.add = this.add.bind(this);
        this.set = this.set.bind(this);
        this.clear = this.clear.bind(this);
        this.render = this.render.bind(this);
        this.subscribe = this.subscribe.bind(this);
        this.unsubscribe = this.unsubscribe.bind(this);
        this.onTimeClose = this.onTimeClose.bind(this);
        this.getInstances = this.getInstances.bind(this);
    }
    Store.prototype.render = function (_position) { };
    Store.prototype.set = function (item) {
        var findIndex = this.instances.findIndex(function (f) { return f.key === item.key; });
        if (findIndex !== -1) {
            var timeoutKey = this.instances[findIndex].timeoutKey;
            // stop hidden element and set new duration
            if (timeoutKey)
                clearTimeout(timeoutKey);
            // update instance item
            this.instances[findIndex] = item;
        }
    };
    Store.prototype.add = function (item) {
        this.instances.push(item);
    };
    Store.prototype.getInstances = function (position) {
        return this.instances.filter(function (f) { return f.position === position; });
    };
    Store.prototype.onTimeClose = function (duration, key, position) {
        var _this = this;
        return setTimeout(function () {
            _this.unsubscribe(key, position);
        }, duration);
    };
    Store.prototype.clear = function (key, resolve) {
        var findItem = this.instances.find(function (f) { return f.key === key; });
        if (findItem && (findItem === null || findItem === void 0 ? void 0 : findItem.timeoutKey)) {
            clearTimeout(findItem.timeoutKey);
            resolve();
        }
    };
    Store.prototype.subscribe = function (_a) {
        var content = _a.content, duration = _a.duration, position = _a.position, key = _a.key, type = _a.type, _b = _a.closable, closable = _b === void 0 ? true : _b;
        // get unique id for identify element
        var _key = key !== null && key !== void 0 ? key : generateUniqueId();
        // get animation className in based to position
        var animation = resolveAnimation(position);
        // timeout key for null onClose
        var timeoutKey = null;
        // verify is set or create element
        var isNew = true;
        // clear and prevent close element
        if (key) {
            this.clear(key, function () { return (isNew = false); });
        }
        // set duration with timeout
        if (duration) {
            timeoutKey = this.onTimeClose(duration, _key, position);
        }
        // set new item for subscribe
        var item = {
            type: type,
            key: _key,
            content: content,
            position: position,
            animation: animation,
            closable: closable,
            timeoutKey: timeoutKey
        };
        // create or update element in the DOM
        if (isNew)
            this.add(item);
        else
            this.set(item);
        // render all elements in the DOM
        this.render(position);
    };
    // remove element from DOM
    Store.prototype.unsubscribe = function (key, position) {
        this.instances = this.instances.filter(function (f) { return f.key !== key; });
        this.render(position);
    };
    return Store;
}());
export default Store;
